import { createStore } from "@xstate/store";

export type AgentMode = "panel" | "floating";

export const agentUiStore = createStore({
  context: { mode: "panel" as AgentMode },
  on: {
    "agent.setMode": (_ctx, e: { mode: AgentMode }) => ({ mode: e.mode }),
  },
});
